<template>
	<div id="personaCollection">
		<div class="personalaccount_content">
			<div class="personalaccount_content_left">
				<div class="personalaccount_content_left_item">
					<div class="personalaccount_content_left_item_head">
						基础功能
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box ">
							<router-link to="/shopcarIndex" >我的购物车</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalOrder" class="">订单管理</router-link>
						</div>
						 <div class="personalaccount_content_left_item_content_box ">
							<router-link to="/personalservice" class="">售后申请</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box select_box">
							<router-link to="/personaCollection" class="select_box">我的收藏</router-link>

						</div>
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalHistory" class="">浏览历史</router-link>
						</div>
					</div>
				</div>
				<div class="personalaccount_content_left_item">
					<div class="personalaccount_content_left_item_head">
						我的优惠信息
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalPackage" class="">我的红包</router-link>
						</div>
						<div class="personalaccount_content_left_item_content_box ">
							<router-link to="/personalIntegral" class="">我的积分</router-link>

						</div>
					</div>
				</div>
				<div class="personalaccount_content_left_item">
					<div class="personalaccount_content_left_item_head">
						发票管理
					</div>
					<div class="personalaccount_content_left_item_content">
						<div class="personalaccount_content_left_item_content_box">
							<router-link to="/personalTicket">申请开票</router-link>
						</div>

					</div>
				</div>

			</div>
			<div class="personalaccount_content_right">
				<div class="personalaccount_content_right_head">
					<div class="personalaccount_content_right_head_left">
						我的收藏
					</div>
					<div class="personalaccount_content_right_head_right">

					</div>
				</div>
				<div class="personalaccount_content_right_content">
					<div class="personalaccount_content_right_content_item" v-for="(item, index) in shoucangData" :key="index" >
						<div class="personalaccount_content_right_content_item_head" @click="jumpDetails(item.goods.id)">
							<img :src=" http + item.goods.cover"/>
						</div>
						<div class="personalaccount_content_right_content_item_center txtnowarp2" @click="jumpDetails(item.goods.id)">
							{{item.goods.title}}
						</div>
						<div class="personalaccount_content_right_content_item_footer">
							<div class="personalaccount_content_right_content_item_footer_txt" @click="jumpDetails(item.goods.id)">
								￥{{item.goods.shop_price}}
							</div>
							<img src="../../../assets/img/personalhome/yishoucang.png" @click="quxiaoCollect(item.goods.id)"/>
						</div>
					</div>
				</div>
        <div class="footer">
          <el-pagination
            background
            layout="prev, pager, next,slot"
            :page-count="getnewallnum"
            @prev-click="huoquCollect(getnewallnums - 1)"
            @next-click="huoquCollect(getnewallnums + 1)"
            @current-change="handleCurrentChange"
            hide-on-single-page
          >
            <span class="allspan">总计:&nbsp;&nbsp;&nbsp;{{getnewallnum}}页</span>
          </el-pagination>
        </div>


			</div>
		</div>
	</div>
</template>

<script>
  import DateSelect from '@/components/DateSelect'
  import qs from "qs";
	export default {
		name: 'personaCollection',

    	components: { DateSelect },
		data() {
			return {
				fixedkey: false,
        http:'',//域名
				shoucangData:[],

        collectData:{},//收藏参数
        getnewallnum:0,//收藏总页数
        getnewallnums: 1, //收藏当前页数,

			}
		},
    created() {
      let that = this;

      if(that.$storage.get('user_data') != null) {
        that.collectData['user_id'] = that.$storage.get('user_data').user_id;
        that.collectData['userrole'] = that.$storage.get('user_data').rank_id;
        // that.collectData['goods_id'] = that.$route.query.goods_id;
        that.huoquCollect();
      } else {
        that.shopData['userrole'] = 1
      }


      that.http = that.$publicUrl.http1;


      // that.getFriend();
    },
		mounted() {

			window.addEventListener('scroll', this.handleScroll)
		},
		methods: {
      //获取收藏列表

      huoquCollect(page = "1") {
        let that = this;
        that.collectData['page'] = page;
        axios({
          method: 'post',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          url: that.$publicUrl.http1 + that.$publicUrl.collectselects,
          data: qs.stringify(that.collectData),

        })
          .then(function(response) {
            //						console.log(response);
            let data = response.data;
            if(data.stateCode == 10000) {
              that.shoucangData = data.data;

              that.getnewallnum = data.page; //公告列表
              that.getnewallnums = Number(page);

            } else {

            }
          })
          .catch(function(error) {
            console.log(error);
          });
      },
      handleCurrentChange(val) {
        let that = this;

        that.huoquCollect(val);
      },
      quxiaoCollect(id) {
        let that = this;
        that.collectData['goods_id'] = id;
        that.$confirm("您将不再收藏该商品?", "系统提示", {
          confirmButtonText: "确定删除",
          cancelButtonText: "我再想想",
          center: true,
          customClass: "alertboxq",
          confirmButtonClass: "alertboxqbtn1"
        })
          .then(() => {
            axios({
              method: 'post',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              },
              url: that.$publicUrl.http1 + that.$publicUrl.collectcancle_goods,
              data: qs.stringify(that.collectData),

            })
              .then(function(response) {
                //						console.log(response);
                let data = response.data;
                if(data.stateCode == 10000) {
                  that.$message({
                    type: "success",
                    message: "您已成功取消收藏!"
                  });
                  that.huoquCollect();
                } else {

                }
              })
              .catch(function(error) {
                console.log(error);
              });
          })
          .catch(() => {});

      },
      jumpDetails(id){
        let that = this;
        that.$router.push({
          path: '/introduce',
          query: {
            goods_id:id,
          }
        })
      },
			handleScroll() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				console.log()
				if(scrollTop >= 300) {
					this.fixedkey = true
				} else {
					this.fixedkey = false

				}
			},
			dateChange(obj) {
				console.log(obj.year + '-' + obj.month + '-' + obj.day);
			}

		},

	}
</script>

<style scoped="scoped">
	#personaCollection {
		width: 100%;
		background-color: #f6f6f6;
		padding-top: 20px;
		padding-bottom: 20px;
	}

	.personalaccount_content {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-wrap: nowrap;
		align-items: self-start;
	}

	.personalaccount_content_left {
		width: 170px;
		text-align: center;
		background: #ffffff;
	}

	.personalaccount_content_left_item_head {
		width: 100%;
		height: 50px;
		line-height: 50px;
		background: #dddddd;
		color: #333333;
		font-size: 18px;
		font-weight: 550;
	}

	.personalaccount_content_left_item_content {
		width: 100%;
	}

	.personalaccount_content_left_item_content_box {
		font-size: 16px;
		color: #333333;
		width: 100%;
		height: 40px;
		margin-top: 10px;
		line-height: 40px;
	}
	.select_box{
		background: #DC1E33;
		color: #ffffff;
	}
	.personalaccount_content_left_item_content_box span {
		color: #DC1E33;
	}

	.personalaccount_content_right {
		width: 1010px;
		margin-left: 20px;
		/*background: #ffffff;*/
	}
	.personalaccount_content_right_content{
		width: 1010px;
    min-height: 590px;
		display: flex;
		flex-wrap: wrap;
		/*justify-content: space-between;*/
	}
	.personalaccount_content_right_head {
		height: 50px;
		line-height: 50px;
		box-sizing: border-box;
		padding-left: 20px;
		padding-right: 20px;
		width: 100%;
		background: #fe818d;
		color: #ffffff;
		font-size: 18px;
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
	}
	.personalaccount_content_right_content_item{
		width: 182px;
    height: 275px;
		background: #ffffff;
		margin-top: 20px;
		margin-right: calc((100% - 182px * 5) / 10);
		margin-left:calc((100% - 182px * 5) / 10) ;
    cursor: pointer;

	}
	.personalaccount_content_right_content_item_head{
		width: 100%;
	}
	.personalaccount_content_right_content_item_head img{
		width: 100%;
    max-height: 182px;
		display: inline-block;
	}
	.personalaccount_content_right_content_item_center{
		font-size: 14px;
		color: #333333;
		margin: 0 auto;
		margin-top: 10px;
    height: 38.4px;
		width: 100%;
		box-sizing: border-box;
		padding-left: 10px;
		padding-right: 10px;
	}
	.personalaccount_content_right_content_item_footer{
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		box-sizing: border-box;
		width: 100%;
		padding: 10px;

	}
	.personalaccount_content_right_content_item_footer img{
		display: inline-block;
		width: 20px;
		height: 19px;
		margin-top: 3px;
	}
	.personalaccount_content_right_content_item_footer_txt{
		color: #DC1E33;
		font-size: 18px;
	}
  .allspan{
    margin: 0 5px;
    color: #606266;
    min-width: 30px;
    border-radius: 2px;
    padding:0 20px;
  }
  .footer{
    width: 100%;
    text-align: center;
    margin: 20px auto;
  }
</style>
